<template>
  <div class="main pl-4" v-if="matches.length > 0">
    <div class="title mb-3">RISULTATI INCONTRI</div>
    <b-container class="my-4" v-if="!showByTeam">
      <b-row class="header text-center">
        <b-col cols="4"><!--***-->Fase</b-col>
        <b-col cols="4"><!--***-->Serie</b-col>
        <b-col cols="4"><!--***-->Girone</b-col>
      </b-row>
      <b-row class="text-center">
        <b-col cols="4">
          <combo-or-label v-model="selectedPhase" :options="availablePhases"></combo-or-label>
        </b-col>
        <b-col cols="4">
          <combo-or-label v-model="selectedSerie" :options="availableSeries"></combo-or-label>
        </b-col>
        <b-col cols="4">
          <combo-or-label v-model="selectedSector" :options="availableSectors"></combo-or-label>
        </b-col>
      </b-row>
      <b-row class="header text-center">
        <b-col cols="4"><!--***-->Sessione</b-col>
        <b-col cols="4"><!--***-->Round</b-col>
      </b-row>
      <b-row class="text-center">
        <b-col cols="4">
          <combo-or-label v-model="selectedSession" :options="availableSessions"></combo-or-label>
        </b-col>
        <b-col cols="4">
          <combo-or-label v-model="selectedRound" :options="availableRounds"></combo-or-label>
        </b-col>
      </b-row>
    </b-container>

    <b-checkbox size="lg" v-model="showByTeam" class="float-right mb-2 ml-2"></b-checkbox>
    <div class="float-right p-1">Mostra per squadra</div>
    <combo-or-label class="my-4" v-if="showByTeam" v-model="selectedTeam" :options="availableTeams"></combo-or-label>


    <b-table
        :fields="fieldsToBeShownInMatches"
        :items="filteredMatchToBeShown"
        small
        striped
        class="figbHeader">
      <template #cell(Tavolo)="data">
        <b-spinner variant="warning" small
                   v-if="data.item.IsBye === 0 && data.item.ActiveBoards > data.item.Confronti"></b-spinner>
        <span v-else style="font-size: 1.5rem">
          <b-icon-check variant="success"></b-icon-check>
        </span><span v-text="data.item.Tavolo"></span>
      </template>
      <template #cell(TeamsName)="data">
        <template v-if="data.item.TriplicateTableIndex > 0">
          <div class="tripl0Text">{{ data.item.TeamHName }} (t)</div>
          <div class="tripl1Text">{{ data.item.TeamVName }} (t)</div>
          <div class="tripl2Text">{{ matchesToBeShown[data.index + 1].TeamHName }} (t)</div>
        </template>
        <template v-else>
          <div class="nsText">{{ data.item.TeamHName }}</div>
          <div class="ewText">{{ data.item.TeamVName }}</div>
        </template>
      </template>
      <template #cell(IMPs)="data">
        <template v-if="data.item.TriplicateTableIndex > 0">
          <div class="tripl0Text">{{ data.item.VerboseImpsH }} (t)</div>
          <div class="tripl1Text">{{ data.item.VerboseImpsV }} (t)</div>
          <div class="tripl2Text">{{ matchesToBeShown[data.index + 1].VerboseImpsH }} (t)</div>
        </template>
        <template v-else>
          <div class="nsText">{{ data.item.VerboseImpsH }}</div>
          <div class="ewText">{{ data.item.VerboseImpsV }}</div>
        </template>
      </template>
      <template #cell(VPs)="data">
        <template v-if="data.item.TriplicateTableIndex > 0">
          <div class="tripl0Text">{{ data.item.VerboseVpH }} (t)</div>
          <div class="tripl1Text">{{ data.item.VerboseVpV }} (t)</div>
          <div class="tripl2Text">{{ matchesToBeShown[data.index + 1].VerboseVpH }} (t)</div>
        </template>
        <template v-else>
          <div class="nsText">{{ data.item.VerboseVpH }}</div>
          <div class="ewText">{{ data.item.VerboseVpV }}</div>
        </template>
      </template>
      <template #cell(bam)="data">
        <template v-if="data.item.TriplicateTableIndex > 0">
          <div class="tripl0Text">{{ data.item.BaMH }} (t)</div>
          <div class="tripl1Text">{{ data.item.BaMV }} (t)</div>
          <div class="tripl2Text">{{ matchesToBeShown[data.index + 1].BaMH }} (t)</div>
        </template>
        <template v-else>
          <div class="nsText">{{ data.item.BaMH }}</div>
          <div class="ewText">{{ data.item.BaMV }}</div>
        </template>
      </template>
      <template #cell(show_details)="row">
        <b-icon-search v-if="row.item.IsBye === 0 && !row.detailsShowing"
                       @click="openDetails(row.item.Group, row.item.Round, row.item.Tavolo)"></b-icon-search>
      </template>

      <template #row-details="row">
        <div class="p-1">
          <div v-if="row.item.TriplicateTableIndex === 0" class="text-center impsResult">
            Imps<br>
            <span class="nsText">{{ row.item.VerboseImpsH }}</span> -
            <span class="ewText">{{ row.item.VerboseImpsV }}</span>
          </div>

          <!--              Disabilitato se triplicato in quanto la chiamata BE "match" non dà i risultati validi (non calcola il triplicato) -->
          <team-rooms
              v-if="row.item.TriplicateTableIndex === 0"
              :line-up="row.item.TablesLineup" :line-up2="row.item.TablesLineup"
              :use-triplicate="row.item.TriplicateTableIndex > 0"></team-rooms>
        </div>
        <b-button class="mt-4 float-right" variant="primary" @click="closeDetails">Chiudi</b-button>
      </template>
    </b-table>
  </div>
</template>

<script>

import ComboOrLabel from "../components/lib/ComboOrLabel";
import {mapActions, mapGetters} from "vuex";
import TeamRooms from "../components/display/TeamRooms";
import {distinctBy} from "@/lib/utils";

export default {
  name: 'Matches',
  components: {TeamRooms, ComboOrLabel},
  data() {
    return {
      selectedPhase: 1,
      selectedSerie: -1,
      selectedSector: -1,
      selectedSession: -1,
      selectedRound: -1,
      selectedTeam: -1,
      currentDetailsSectorRoundTable: -1
    }
  },
  computed: {
    ...mapGetters({
      teamId: 'tournament/teamId',
      contestType: 'tournament/contestType',
      matches: 'matches/matches',
      played: 'deals/played',
      teamsList: 'players/teamsList',
      pairsList: 'players/pairsList',
      currentRound: 'tournament/currentRound',
      sectors: 'tournament/sector',
      teamRanks: 'ranks/teamRanks',
      _showByTeam: 'webApp/showByTeam'
    }),
    showByTeam: {
      get() {
        return this._showByTeam;
      },
      set(newValue) {
        this.changeShowByTeam(newValue);
      }
    },
    matchesToBeShown() {
      let matches = this.matches;

      if (this.showByTeam) {
        matches = matches.filter(infoRound => [infoRound.TeamHId, infoRound.TeamVId].includes(this.selectedTeam)).map(row => {
          row._showDetails = this.sectorRoundTableKey(row.Group, row.Round, row.Tavolo) === this.currentDetailsSectorRoundTable;
          return row;
        });
      } else {
        matches = matches
            .filter(infoRound => infoRound.Series === this.selectedSerie)
            .filter(infoRound => infoRound.Group === this.selectedSector)
            .filter(infoRound => infoRound.Session === this.selectedSession)
            .filter(infoRound => infoRound.Round === this.selectedRound)
            .map(row => {
              row._rowVariant = [row.TeamHId, row.TeamVId].includes(this.teamId) ? 'warning' : undefined;
              row._showDetails = this.sectorRoundTableKey(row.Group, row.Round, row.Tavolo) === this.currentDetailsSectorRoundTable;
              return row;
            });
      }

      return matches
          .sort((a, b) => a.Table - b.Table);
    },
    filteredMatchToBeShown() {
      return this.matchesToBeShown.filter(match => [0, 1].includes(match.TriplicateTableIndex));
    },
    availableTeams() {
      return [
        ...new Set(this.matches
            .filter(infoRound => infoRound.IsBye === 0)
            .flatMap(infoRound => [infoRound.TeamHId, infoRound.TeamVId])
        )
      ]
          .map(teamId => {
            return {
              text: this.teamsList[teamId]?.Name ?? this.pairsList[teamId]?.Name,
              value: teamId
            };
          })
          .sort((a, b) => a.text.localeCompare(b.text))
    },
    availablePhases() {
      return [...new Set(this.matches.map(infoRound => infoRound.Phase))].sort((a, b) => a - b);
    },
    availableSeries() {
      const currentMatches = this.matches
          .filter(infoRound => infoRound.Phase === this.selectedPhase)

      return distinctBy(currentMatches, infoMatch => infoMatch.Series)
          .map(infoRound => {
            return {
              value: infoRound.Series,
              text: this.sectors.Phases[this.selectedPhase].Series[infoRound.Series].Sigla
            }
          }).sort((a, b) => a.text.localeCompare(b.text));
    },
    availableSectors() {
      const currentMatches = this.matches
          .filter(infoRound => infoRound.Series === this.selectedSerie);

      return distinctBy(currentMatches, infoMatch => infoMatch.Group)
          .map(infoRound => {
            return {
              value: infoRound.Group,
              text: infoRound.GroupLabel
            }
          }).sort((a, b) => a.text.localeCompare(b.text));
    },
    availableSessions() {
      return [...new Set(this.matches
          .filter(infoRound => infoRound.Series === this.selectedSerie)
          .filter(infoRound => infoRound.Group === this.selectedSector)
          .map(infoRound => infoRound.Session)
      )].sort((a, b) => a - b);
    },
    availableRounds() {
      return [...new Set(this.matches
          .filter(infoRound => infoRound.Series === this.selectedSerie)
          .filter(infoRound => infoRound.Group === this.selectedSector)
          .filter(infoRound => infoRound.Session === this.selectedSession)
          .map(infoRound => infoRound.Round))].sort((a, b) => a - b);
    },
    fieldsToBeShownInMatches() {
      const showBaM = this.matchesToBeShown.some(m => m.BaMH !== 0 || m.BaMV !== 0);

      return [
        {
          key: 'Tavolo',
          label: ''
        },
        {
          key: 'TeamsName',
          label: 'Squadre'
        }, {
          key: 'VPs',
          label: 'VP'
        },
        (showBaM ? {
          key: 'bam',
          label: 'BaM'
        } : null),
        {
          key: 'show_details',
          label: ''
        }
      ];
    },
  },
  methods: {
    ...mapActions({
      changeShowByTeam: 'webApp/changeShowByTeam',
    }),
    openDetails(sector, round, table) {
      this.currentDetailsSectorRoundTable = this.sectorRoundTableKey(sector, round, table);
    },
    closeDetails() {
      this.openDetails(0, 0, 0);
    },
    sectorRoundTableKey(sector, round, table) {
      return sector * 1000000 + round * 1000 + table;
    }
  },
  watch: {
    selectedSession() {
      this.closeDetails();
    },
    selectedRound() {
      this.closeDetails();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.selectedPhase = Math.max(...this.availablePhases);
      this.$nextTick(() => {

        this.selectedRound = Math.max(...this.availableRounds);
        this.$nextTick(() => {
          const playedSeries = Object.keys(this.played
              ?.Phases[this.selectedPhase].Series ?? {});

          if (playedSeries.length === 1) {
            this.selectedSerie = parseInt(playedSeries[0]);
          }

          this.$nextTick(() => {
            let playedGroups;

            if (this.contestType === 0) {

              //Torneo a squadre
              playedGroups = Object.keys(this.played
                  ?.Phases[this.selectedPhase]?.Series[this.selectedSerie]?.Groups ?? {});
            } else {
              //Torneo a coppie, di solito Danese, non abbiamo le serie e gironi (lavoriamo per rankset)
              playedGroups = [1];
            }

            if (playedGroups.length === 1) {
              this.selectedSector = parseInt(playedGroups[0]);
            }

            this.$nextTick(() => {
              this.selectedSession = Math.max(...this.availableSessions);
              this.$nextTick(() => {
                this.selectedRound = Math.max(...this.availableRounds);
              });
            });

          });
        });
      });
    });
    this.selectedTeam = this.teamId !== -1 ? this.teamId : Math.min(...this.availableTeams);
  }
};
</script>

<style scoped>
.nsText {
  color: #2661CE;
  font-weight: bold;
}

.ewText {
  color: #DC143C;
  font-weight: bold;
}

.tripl0Text {
  color: #72ba01;
  font-weight: bold;
}

.tripl1Text {
  color: #548303;
  font-weight: bold;
}

.tripl2Text {
  color: #42630f;
  font-weight: bold;
}

.impsResult {
  font-size: 2rem;
}

/deep/ .table > tbody > tr > td {
  vertical-align: middle;
}


.header {
  font-weight: bold;
}


.title {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  color: #3396B8;
}


>>> .figbHeader thead {
  color: #3396B8;
  background-color: white;
}
</style>
